import { render, staticRenderFns } from "./Synology.vue?vue&type=template&id=73e517a9"
import script from "./Synology.vue?vue&type=script&lang=js"
export * from "./Synology.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports